// Org-scoped on purpose, like V1's loading: the panel also needs the agent's
// team flag (useIsTeamAssistV2Enabled), but a customer's session loads when the
// customer does, which can be before the teams store has loaded.
export default function isTeamAssistV2Enabled(appFeatures) {
  return (
    Boolean(appFeatures) &&
    appFeatures.isEnabled('teamAssistAI') &&
    appFeatures.isEnabled('conversation:general') &&
    appFeatures.isEnabled('teamAssistV2')
  );
}
